import { datadogLogs } from '@datadog/browser-logs';
import { showToast } from 'components/Toast';
import { getApiDebuggingId, getApiErrorStatus, getApiHttpStatus } from 'helpers/rtk-utils';
import { useUpdateClientFilterMutation } from 'services/clientFiltersApi';
import { FILTER_SAVED, FILTER_STATUS_ERROR } from './constants';
import { trackEvent } from 'helpers/mixpanelEvents';

export const useSaveFilterStatus = (clientId: number) => {
  const [updateFilter] = useUpdateClientFilterMutation();

  return (filterId: string, isActive: boolean): Promise<void> =>
    updateFilter({ clientId, filterId, body: { status: isActive ? 'ACTIVE' : 'PAUSED' } })
      .unwrap()
      .then(() => {
        trackEvent('Filter Status Changed', {
          screen: 'filters',
          status: isActive ? 'ACTIVE' : 'PAUSED',
        });
        showToast(FILTER_SAVED, 'success');
      })
      .catch((error: unknown) => {
        datadogLogs.logger.error(
          'Failed to update client filter status',
          {
            client_id: clientId,
            filter_id: filterId,
            status: getApiErrorStatus(error),
            debugging_id: getApiDebuggingId(error),
          },
          error instanceof Error ? error : undefined
        );
        showToast(FILTER_STATUS_ERROR, 'error', getApiHttpStatus(error));
      });
};
